import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createSlots as _createSlots, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-304b78ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bien-ban-giai-the-form-rows-wrapper" }
const _hoisted_2 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_3 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_6 = { class: "d-flex flex-column align-items-start w-100 h-full justify-content-between" }
const _hoisted_7 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_8 = ["checked", "disabled"]
const _hoisted_9 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_10 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_13 = { class: "w-100 d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddVatTuItemV2 = _resolveComponent("AddVatTuItemV2")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_BaseLink = _resolveComponent("BaseLink")!
  const _component_ResponsiveLayout = _resolveComponent("ResponsiveLayout")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_AddVatTuTableItems = _resolveComponent("AddVatTuTableItems")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AddVatTuItemV2, {
      "is-modal-open": _ctx.isDinhMucDongModalOpen,
      "use-for": _ctx.AddVatTuItemsFor.DINH_MUC,
      "vat-tu-selected": _ctx.vatTuItems,
      onAdded: _ctx.onAddedVatTu,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDinhMucDongModalOpen = false))
    }, null, 8, ["is-modal-open", "use-for", "vat-tu-selected", "onAdded"]),
    _createVNode(_component_PageContentBase, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.form,
          rules: _ctx.rules,
          onSubmit: _withModifiers(() => {}, ["prevent"])
        }, {
          default: _withCtx(() => [
            (_ctx.editApprovalAlertMessage)
              ? (_openBlock(), _createBlock(_component_el_alert, {
                  key: 0,
                  class: "mb-4",
                  closable: false,
                  "show-icon": "",
                  title: _ctx.editApprovalAlertMessage,
                  type: "warning"
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            (_ctx.isBelongedToKeHoach)
              ? (_openBlock(), _createBlock(_component_ResponsiveLayout, { key: 1 }, _createSlots({
                  "col-1": _withCtx(() => [
                    _createVNode(_component_LabelCustom, { "is-text-muted": false }, {
                      default: _withCtx(() => [
                        _createTextVNode("Kế hoạch:")
                      ]),
                      _: 1
                    })
                  ]),
                  "col-3": _withCtx(() => [
                    _createVNode(_component_LabelCustom, { "is-text-muted": false }, {
                      default: _withCtx(() => [
                        _createTextVNode("DM toa xe:")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, [
                  (_ctx.keHoachDetail)
                    ? {
                        name: "col-2",
                        fn: _withCtx(() => [
                          _createVNode(_component_BaseLink, {
                            to: {
                  name: _ctx.isKeHoachNam
                    ? 'chi-tiet-ke-hoach-nam'
                    : 'chi-tiet-ke-hoach-sua-chua',
                  params: {
                    id: _ctx.keHoachDetail.id,
                  },
                },
                            isOpenInNewTab: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.keHoachDetail.id) + " - " + _toDisplayString(_ctx.keHoachDetail.ten_ke_hoach), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        key: "0"
                      }
                    : undefined,
                  (_ctx.keHoachDetail?.danh_muc_toa_xe.id)
                    ? {
                        name: "col-4",
                        fn: _withCtx(() => [
                          _createVNode(_component_BaseLink, {
                            to: {
                  name: 'chi-tiet-danh-muc-toa-xe',
                  params: {
                    id: _ctx.keHoachDetail.danh_muc_toa_xe.id,
                  },
                },
                            isOpenInNewTab: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.keHoachDetail?.danh_muc_toa_xe.id) + " - " + _toDisplayString(_ctx.keHoachDetail?.danh_muc_toa_xe.ten_danh_muc), 1)
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]),
                        key: "1"
                      }
                    : undefined
                ]), 1024))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_DivRow, { class: "mb-3 g-3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_DivCol, {
                    "additional-class": "pb-4",
                    cols: 3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_LabelCustom, {
                          "is-text-muted": false,
                          "is-required": "",
                          class: "bien-ban-giai-the-form-label-clickable",
                          onClick: _ctx.focusToaXeInput
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Toa xe")
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_el_form_item, {
                          class: "mb-0 w-100",
                          prop: "ten_toa_xe"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_autocomplete, {
                              modelValue: _ctx.form.ten_toa_xe,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.ten_toa_xe) = $event)),
                              ref: "toaXeSearchRef",
                              class: "w-100",
                              clearable: "",
                              placeholder: "Tìm kiếm toa xe",
                              disabled: 
                      _ctx.isSearchForToaXeInputDisabled ||
                      _ctx.isCreatingBienBanGiaiTheBoSung
                    ,
                              "trigger-on-focus": false,
                              "fetch-suggestions": _ctx.queryToaXe,
                              "highlight-first-item": true,
                              onFocus: _cache[2] || (_cache[2] = ($event: any) => ($event.target.select())),
                              onSelect: _ctx.onSelectToaXe,
                              onInput: _ctx.onToaXeInput,
                              onClear: _ctx.onClearToaXe
                            }, {
                              default: _withCtx(({ item }) => [
                                _createElementVNode("span", null, [
                                  _createElementVNode("strong", null, _toDisplayString(item.ma_toa_xe) + " - ", 1)
                                ]),
                                _createElementVNode("span", null, _toDisplayString(item.ten_toa_xe), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled", "fetch-suggestions", "onSelect", "onInput", "onClear"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DivCol, {
                    "additional-class": "pb-4",
                    cols: 4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_LabelCustom, {
                          "is-required": !_ctx.isBelongedToKeHoach,
                          "is-text-muted": false,
                          class: _normalizeClass({
                    'bien-ban-giai-the-form-label-clickable':
                      !_ctx.isBelongedToKeHoach,
                  }),
                          onClick: _ctx.focusCapSuaChuaSelect
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Cấp SC")
                          ]),
                          _: 1
                        }, 8, ["is-required", "class", "onClick"]),
                        (_ctx.isBelongedToKeHoach)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.keHoachDetail?.cap_sua_chua)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.keHoachDetail.cap_sua_chua.ten_cap_sc), 1))
                                : (_openBlock(), _createBlock(_component_LabelCustom, {
                                    key: 1,
                                    isTextMuted: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("-")
                                    ]),
                                    _: 1
                                  }))
                            ], 64))
                          : (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 1,
                              prop: "cap_sua_chua_id",
                              class: "mb-0 w-100"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select, {
                                  ref: "capSuaChuaSelectRef",
                                  modelValue: _ctx.form.cap_sua_chua_id,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.cap_sua_chua_id) = $event)),
                                  class: "w-full",
                                  placeholder: "Chọn nhóm",
                                  disabled: _ctx.isCreatingBienBanGiaiTheBoSung
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: "Chưa chọn",
                                      value: 0
                                    }),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.capSuaChuaItems, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        value: item.id,
                                        label: item.ten_cap_sc
                                      }, null, 8, ["value", "label"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled"])
                              ]),
                              _: 1
                            }))
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DivCol, {
                    "additional-class": "pb-4",
                    cols: 3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_LabelCustom, {
                          "is-text-muted": false,
                          "is-required": true,
                          class: "bien-ban-giai-the-form-label-clickable",
                          onClick: _ctx.focusNgayVaoXuongPicker
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Ngày vào xưởng")
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_el_form_item, {
                          prop: "ngay_vao_xuong",
                          class: "mb-0 w-100"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              ref: "ngayVaoXuongPickerRef",
                              modelValue: _ctx.form.ngay_vao_xuong,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.ngay_vao_xuong) = $event)),
                              "allow-before-global-min": "",
                              disabled: !_ctx.isCreating,
                              "disabled-date": _ctx.disabledNgayVaoXuongDate,
                              class: "w-100",
                              placeholder: "Chọn ngày",
                              name: "signDate",
                              format: "DD/MM/YYYY"
                            }, null, 8, ["modelValue", "disabled", "disabled-date"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DivCol, {
                    "additional-class": "pb-4",
                    cols: 2
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_LabelCustom, {
                          "is-text-muted": false,
                          class: "bien-ban-giai-the-form-label-clickable",
                          onClick: _ctx.toggleNgoaiDinhMuc
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Ngoài định mức")
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_el_form_item, {
                          prop: "has_dinh_muc_dong",
                          class: "mb-0"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("input", {
                                class: "form-check-input h-20px w-30px",
                                type: "checkbox",
                                value: "",
                                id: "flexSwitchChecked",
                                checked: _ctx.form.has_dinh_muc_dong,
                                disabled: !_ctx.isCreating && !_ctx.form.can_edit_dmd,
                                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.has_dinh_muc_dong = $event.target.checked))
                              }, null, 40, _hoisted_8)
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DivRow, { class: "mb-3 g-3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_DivCol, {
                    "additional-class": "pb-4",
                    cols: 3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_LabelCustom, {
                          "is-text-muted": false,
                          "is-required": false
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Nhóm Toa Xe ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { class: "mb-0 w-100 bien-ban-giai-the-form-item-display" }, {
                          default: _withCtx(() => [
                            (!_ctx.danhMucToaXeId)
                              ? (_openBlock(), _createBlock(_component_LabelCustom, {
                                  key: 0,
                                  isTextMuted: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Vui lòng chọn toa xe")
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_BaseLink, {
                                  key: 1,
                                  to: {
                      name: 'chi-tiet-danh-muc-toa-xe',
                      params: {
                        id: _ctx.danhMucToaXeId,
                      },
                    },
                                  isOpenInNewTab: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.tenDanhMucToaXe), 1)
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DivCol, {
                    "additional-class": "pb-4",
                    cols: 3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_LabelCustom, {
                          "is-text-muted": false,
                          "is-required": true
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Số biên bản")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          prop: "so_bien_ban",
                          class: "mb-0 w-100 bien-ban-giai-the-form-item-display"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.form.so_bien_ban)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.form.so_bien_ban), 1))
                              : (_openBlock(), _createBlock(_component_LabelCustom, {
                                  key: 1,
                                  isTextMuted: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Tự động tạo khi đủ thông tin")
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DivCol, {
                    "additional-class": "pb-4",
                    cols: 6
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_LabelCustom, {
                          "is-text-muted": false,
                          "is-required": false
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Đ/mức cố định ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { class: "mb-0 w-100 bien-ban-giai-the-form-item-display" }, {
                          default: _withCtx(() => [
                            (_ctx.capSuaChuaAndDmToaXeAvailable && _ctx.dinhMucCoDinhDetail)
                              ? (_openBlock(), _createBlock(_component_BaseLink, {
                                  key: 0,
                                  isOpenInNewTab: "",
                                  to: {
                      name: 'chi-tiet-dinh-muc-co-dinh',
                      params: {
                        id: _ctx.dinhMucCoDinhDetail.id,
                      },
                    }
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.dinhMucCoDinhDetail.danh_muc_toa_xe.ten_danh_muc) + " (" + _toDisplayString(_ctx.dinhMucCoDinhDetail.cap_sua_chua.ten_cap_sc) + ") ", 1)
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : _createCommentVNode("", true),
                            (_ctx.capSuaChuaAndDmToaXeAvailable && !_ctx.dinhMucCoDinhDetail)
                              ? (_openBlock(), _createBlock(_component_LabelCustom, {
                                  key: 1,
                                  isTextMuted: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Không có định mức cố định tương ứng với CSC và nhóm toa xe này ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (!_ctx.capSuaChuaAndDmToaXeAvailable)
                              ? (_openBlock(), _createBlock(_component_LabelCustom, {
                                  key: 2,
                                  isTextMuted: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Vui lòng chọn cấp sửa chữa và toa xe ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_ResponsiveLayout, null, {
              "col-4": _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.form.has_dinh_muc_dong)
                    ? (_openBlock(), _createBlock(_component_ButtonCustom, {
                        key: 0,
                        "button-type": _ctx.ButtonsType.ADD,
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isDinhMucDongModalOpen = true))
                      }, {
                        "button-label": _withCtx(() => [
                          _createTextVNode(" Thêm vật tư ")
                        ]),
                        _: 1
                      }, 8, ["button-type"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ButtonCustom, {
                    "button-type": _ctx.ButtonsType.SAVE,
                    "color-type": _ctx.ButtonTypeColors.SUCCESS,
                    onClick: _ctx.submit
                  }, {
                    "button-label": _withCtx(() => [
                      _createTextVNode("Lưu")
                    ]),
                    _: 1
                  }, 8, ["button-type", "color-type", "onClick"])
                ])
              ]),
              _: 1
            }),
            (_ctx.form.has_dinh_muc_dong)
              ? (_openBlock(), _createBlock(_component_AddVatTuTableItems, {
                  key: 2,
                  "disable-ghi-chu-input": false,
                  items: _ctx.vatTuItems,
                  "is-loading": false,
                  "is-so-luong-editable": true,
                  "show-ghi-chu-input": true,
                  onOnDelete: _ctx.onRemovingVatTu,
                  onSoLuongChange: _ctx.soLuongChangedHandler,
                  onUpdateGhiChu: _ctx.ghiChuUpdateHandler
                }, null, 8, ["items", "onOnDelete", "onSoLuongChange", "onUpdateGhiChu"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    })
  ], 64))
}